/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const TemplatesIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.7891 14.3828"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <g>
        <rect height="14.3828" opacity="0" width="14.7891" x="0" y="0"/>
        <path d="M14.3828 2.42188L14.3828 11.9688C14.3828 13.5781 13.5703 14.3828 11.9297 14.3828L2.45312 14.3828C0.820312 14.3828 0 13.5781 0 11.9688L0 2.42188C0 0.8125 0.820312 0 2.45312 0L11.9297 0C13.5703 0 14.3828 0.8125 14.3828 2.42188ZM3.86719 4.69531L3.86719 5.69531C3.86719 6.27344 3.72656 6.41406 3.32812 6.51562C2.64844 6.69531 2.64844 7.69531 3.32812 7.875C3.72656 7.98438 3.86719 8.125 3.86719 8.70312L3.86719 9.70312C3.86719 10.9609 4.51562 11.5859 5.60156 11.5859C6.08594 11.5859 6.35938 11.3594 6.35938 11.0312C6.35938 10.7031 6.11719 10.4922 5.79688 10.4922C5.25 10.4922 5.04688 10.2578 5.04688 9.59375L5.04688 8.49219C5.04688 7.87081 4.71405 7.39542 4.15391 7.19278C4.71405 6.99521 5.04688 6.51981 5.04688 5.89844L5.04688 4.80469C5.04688 4.14062 5.25 3.89844 5.79688 3.89844C6.11719 3.89844 6.35938 3.69531 6.35938 3.36719C6.35938 3.03906 6.08594 2.80469 5.60156 2.80469C4.51562 2.80469 3.86719 3.4375 3.86719 4.69531ZM8.04688 3.36719C8.04688 3.69531 8.28906 3.89844 8.60938 3.89844C9.15625 3.89844 9.35938 4.14062 9.35938 4.80469L9.35938 5.89844C9.35938 6.51981 9.6922 6.99521 10.2523 7.19278C9.6922 7.39542 9.35938 7.87081 9.35938 8.49219L9.35938 9.59375C9.35938 10.2578 9.15625 10.4922 8.60938 10.4922C8.28906 10.4922 8.04688 10.7031 8.04688 11.0312C8.04688 11.3594 8.32031 11.5859 8.80469 11.5859C9.89062 11.5859 10.5391 10.9609 10.5391 9.70312L10.5391 8.70312C10.5391 8.125 10.6797 7.98438 11.0781 7.875C11.7578 7.70312 11.7578 6.6875 11.0781 6.51562C10.6797 6.41406 10.5391 6.27344 10.5391 5.69531L10.5391 4.69531C10.5391 3.4375 9.89062 2.80469 8.80469 2.80469C8.32031 2.80469 8.04688 3.03906 8.04688 3.36719Z" fill={ color }/>
      </g>
    </svg>
  );
});
